import { ViewMode } from '@/hooks/useViewMode';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import { Box, CircularProgress, IconButton, Tooltip, useTheme } from '@mui/material';
import { useTransition } from 'react';

export const ViewModeToggle = ({
  viewMode,
  onViewModeChange,
}: {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}) => {
  const theme = useTheme();
  const [isPending, startTransition] = useTransition();

  const handleChange = (mode: ViewMode) => {
    startTransition(() => {
      onViewModeChange(mode);
    });
  };

  const targetMode = viewMode === 'card' ? 'table' : 'card';
  const label = viewMode === 'card' ? 'Table view' : 'Card view';
  const Icon = viewMode === 'card' ? ViewListIcon : GridViewIcon;

  return (
    <Tooltip title={label} placement='bottom'>
      <Box
        sx={{
          position: 'relative',
          width: 28,
          height: 28,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          size='small'
          onClick={() => handleChange(targetMode)}
          disabled={isPending}
          sx={{
            color: theme.palette.text.primary,
            '&:hover': { backgroundColor: theme.palette.action.hover },
            '&.Mui-disabled': { color: theme.palette.text.secondary },
          }}
        >
          <Icon fontSize='small' />
        </IconButton>
        {isPending && (
          <CircularProgress
            size={26}
            thickness={2}
            sx={{
              position: 'absolute',
              top: 1,
              left: 1,
              color: theme.palette.primary.main,
              pointerEvents: 'none',
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};
